// What the bundle pages show of money, pages and days

export const money = (value) => Number(value).toLocaleString() + "₮";

// A bundle keeps half pages: a colored page takes one and a half
export const pagesText = (pages) => String(pages).replace(".5", ",5");

// A bundle's dates are the real time; the day is Ulaanbaatar's
export const dayText = (date) => {
  if (!date) return "";
  const shifted = new Date(new Date(date).getTime() + 8 * 60 * 60 * 1000);
  return shifted.toISOString().slice(0, 10);
};

// The link a bundle's owner sends their friends
export const inviteLink = (code) => "https://cloudprint.mn/join?c=" + encodeURIComponent(code);

// The message of an API error, or the fallback
export const errorOf = (err, fallback) => {
  const errors = err && err.response && err.response.data && err.response.data.errors;
  return (errors && errors[0] && errors[0].msg) || fallback;
};
